import React, { useState, useEffect } from "react";
import { Button, Icon } from "../../../components/Component";
import { Row, Alert, Modal, ModalHeader, ModalBody, Col } from "reactstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import FormCheckbox from "../../form-components/CheckboxComponent";
import usersApis from "../../../api/master/users";
import moment from "moment";
import rolesApi from "../../../api/master/roles";
import UserAccessibilityModal from "./UserAccessibilityModal";
import { get } from "http";

interface SelectOptions {
  label: string;
  value: string;
}
const Accessibility: React.FC = (props: any) => {
  const navigate = useNavigate();

  const methods = useForm({
    mode: "onChange",
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    reset,
  } = useFormContext();
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [alertInfo, setAlertInfo] = useState<any>({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });

  const [data, setData] = useState<any>();
  const [formData, setFormData] = useState({
    accessibility: [],
  });
  const formWatch = watch();
  const [accessibilityKeys, setaccessibilityKeys] = useState([]);
  const [accessibilityModalData, setAccessibilityModalData] = useState<any[]>(
    []
  );

  useEffect(() => {
    // fetchModuleConfig();
    const formAccessibility = getValues("accessibility");
    if (
      formWatch.role &&
      (!formAccessibility || formAccessibility.length === 0)
    ) {
      fetchRoleById(formWatch.role, formWatch);
    }
  }, []);

  useEffect(() => {
    if (
      data &&
      (!getValues("accessibility") || getValues("accessibility").length === 0)
    ) {
      console.log("useEffect::data.accessibility", data);
      setValue("accessibility", data);
    }
  }, [data]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState<string | null>(null);

  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };

  const formatAccessibilityData = (accessibility: any) => {
    const formattedModules = accessibility.flatMap((entry: any) => {
      // Case 1: "Reports" - nested categories inside modules
      if (entry.category === "Reports") {
        return entry.modules.flatMap((subCat: any) =>
          subCat.modules.map((mod: any) => ({
            module: String(mod.moduleID),
            add: !!mod.actions?.add,
            view: !!mod.actions?.view,
            edit: !!mod.actions?.edit,
            cancel: !!mod.actions?.cancel,
            approve: !!mod.actions?.approve,
            reject: !!mod.actions?.reject,
          }))
        );
      }

      // Case 2: Normal categories
      return entry.modules.map((mod: any) => ({
        module: String(mod.moduleID),
        add: !!mod.actions?.add,
        view: !!mod.actions?.view,
        edit: !!mod.actions?.edit,
        cancel: !!mod.actions?.cancel,
        approve: !!mod.actions?.approve,
        reject: !!mod.actions?.reject,
      }));
    });
    return formattedModules;
  };

  const submitForm = (formData: any) => {
    console.log("data", formData, getValues("accessibility"));
    const formdat = formatAccessibilityData(
      getValues("accessibility")?.accessibility
    );
    console.log("formdat", formdat);
    formData.accessibility = formdat;
    console.log("formdata", formData);
    if (formData.isContractorUser == "Y") {
      formData.isContractorUser = true;
    } else if (formData.isContractorUser == "N") {
      formData.isContractorUser = false;
    }
    formData.DOB = formData.DOB
      ? moment(formData.DOB).format("YYYY-MM-DD")
      : null;
    formData.DOJ = formData.DOJ
      ? moment(formData.DOJ).format("YYYY-MM-DD")
      : null;

    const hasSequence = getValues("hasSequence");

    if (hasSequence) {
      delete formData.referenceID;
    } else {
      formData.referenceID = getValues("referenceID");
    }

    createUser(formData);
  };

  const createUser = async (data: any) => {
    delete data.reportingManagerRoleName;
    delete data.departmentName;
    console.log("Final form data:", data);
    const { status, message } = await usersApis.createBuyer(data);
    if (status) {
      Swal.fire("Created!", "User has been created", "success");
      navigate(`/users`);
    } else {
      let errorMessage = "An error occurred";
      let fullErrorMessage;
      if (typeof message == "string") {
        fullErrorMessage = `${errorMessage}\n${"-"}\n${message}`;
      } else {
        fullErrorMessage = `${errorMessage}\n${"-"}\n${message?.join(" ")}`;
      }
      setAlertInfo({
        type: "error",
        message: fullErrorMessage,
        errors: [],
      });
    }
  };

  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.getModuleConfig();
      const data = res.data;
      setaccessibilityKeys(data);
    } catch (err) {
      throw err;
    }
  };

  const fetchRoleById = async (id: any, Data: any) => {
    try {
      const { data, status, message } = await rolesApi.fetchRoleById(id);
      if (status) {
        const newData = data;
        console.log("newData", newData);
        setData(newData);
      }
    } catch (err: any) {
      Swal.fire(
        "Failed!",
        err.response?.data?.message || "Unknown error",
        "error"
      );
    }
  };

  const openGrantAccessModal = (moduleName: string) => {
    const latestAccessibility = getValues("accessibility") || [];
    setAccessibilityModalData(latestAccessibility);

    setSelectedModule(moduleName);
    setModalOpen(true);
  };

  return (
    <>
      {alertInfo.message && (
        <div className="mb-3 mt-1">
          <Alert
            color={alertInfo.type === "error" ? "danger" : "success"}
            className="alert-icon"
          >
            <strong>{alertInfo.message}</strong>
            <Icon
              name={
                alertInfo.type === "error" ? "alert-circle" : "check-circle"
              }
            />
            {alertInfo.errors.length > 0 ? (
              <ul>
                {alertInfo.errors.map((err: any, index: any) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </Alert>
        </div>
      )}
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="12">
            <div className="form-group">
              <label className="form-label">Accessibility</label>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              ></div>
              {getValues("accessibility")?.accessibility.map(
                (item: any, idx: number) => (
                  <div
                    key={item.category}
                    className="data-col align-center pt-1 pl-2 "
                  >
                    <div className="data-label w-45">{item.category}</div>
                    <div className="data-value w-55 ">
                      <a
                        href="#"
                        className="ml-3"
                        onClick={(e) => {
                          e.preventDefault();
                          openGrantAccessModal(item.category);
                        }}
                        style={{ fontSize: 14, color: "#6576ff" }}
                      >
                        View Access Details
                      </a>
                    </div>
                  </div>
                )
              )}
            </div>
          </Col>
        </Row>

        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit">
                Submit Form
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={props.prev}
                className="btn-dim btn btn-secondary"
              >
                Previous
              </Button>
            </li>
          </ul>
        </div>
      </form>
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          {selectedModule} Access Details
        </ModalHeader>
        <ModalBody>
          <UserAccessibilityModal
            selectedViewDetailsName={selectedModule}
            data={accessibilityModalData}
            onSave={(data: any) => {
              console.log("data", data);
              setModalOpen(false);
              setValue("accessibility", data);
              setData(data);
            }}
            onCancel={() => {
              toggleModal();
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
export default Accessibility;
